export function encode(app, screen, step, data) {
    const d = data ? A2B(JSON.stringify(data)) : "-";
    return `/${app}/#/${screen}/${step || "-"}/${d}`.replace(/\/\//g, "/");
}
export function decode(fullPath) {
    // fullPath: /app/#/signIn/-/eyJhIjoxLCJiIjoiMiJ9
    // parts = ['', 'app', '#', 'signIn', '-', 'eyJhIjoxLCJiIjoiMiJ9']
    const parts = fullPath.split("/");
    const app = parts[1];
    const screen = parts[3];
    const stepStr = parts[4];
    const step = !stepStr || stepStr === "-" ? undefined : stepStr;
    const dataStr = parts[5];
    const data = !dataStr || dataStr === "-" ? undefined : JSON.parse(B2A(dataStr));
    return {
        app,
        screen,
        step,
        data,
    };
}
function A2B(str) {
    if (typeof Buffer === "function") {
        // node
        return Buffer.from(str).toString("base64");
    }
    else {
        // browser
        return btoa(str);
    }
}
function B2A(base64) {
    if (typeof Buffer === "function") {
        // node
        return Buffer.from(base64, "base64").toString("ascii");
    }
    else {
        // browser
        return atob(base64);
    }
}
/* test
const a = encode("app", "signIn", undefined, { a: 1, b: "2" });
console.log(a);
const b = decode(a);
console.log(JSON.stringify(b));
*/
//# sourceMappingURL=redirect.js.map